import { render, staticRenderFns } from "./vTableEditable.vue?vue&type=template&id=3f015f36"
import script from "./vTableEditable.vue?vue&type=script&lang=js"
export * from "./vTableEditable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports